import { jsx } from "react/jsx-runtime";
import { PeopleMenu } from "./PeopleMenu.mjs";
function DefaultSharePanel() {
  return /* @__PURE__ */ jsx("div", { className: "tlui-share-zone", draggable: false, children: /* @__PURE__ */ jsx(PeopleMenu, { displayUserWhenAlone: true }) });
}
export {
  DefaultSharePanel
};
//# sourceMappingURL=DefaultSharePanel.mjs.map
